import cloneDeep from 'lodash/cloneDeep';
import Cookies from 'js-cookie';
import * as RegExps from './regexp';

export * from './webview';
export * from './location';
export * from './browser';
export * from './encrypt';
export { RegExps };

export function clone(data) {
    return cloneDeep(data);
}

/**
 * @description 解析二进制字符串，从中获取当前支持的三方登录
 * @param {string} loginType 二进制字符串
 */
export function parseOAuths(loginType) {
    const oauths = loginType.split('').map(t => +t);

    return oauths.reduce((prev, num, index) => {
        if (num === 1) {
            const auth = (num * 10 ** (oauths.length - 1 - index)).toString();
            prev.push(auth);
        }
        return prev;
    }, []);
}

// 解析 JSON
export function jsonParser(text, reviver) {
    if (typeof text === 'string') {
        try {
            return JSON.parse(text, reviver);
        } catch (error) {
            console.error(`${text} is not a JSON`);
            return null;
        }
    }
    return null;
}

/**
 * @description 天御验证
 * @see https://cloud.tencent.com/document/product/1110/36841
 * @param {string} captchaAppId 登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
 * @param {function} callback 验证结束后，调用回调函数，并在第一个参数中传入回调结果（包括成功和失败）。
 * @param {function} loadErrorCallback 加载异常，调用验证码js加载错误处理函数
 * @param {(Record<string, any>)} options 外观配置参数
 * @return { object } 返回验证码实例，以便调用显示、隐藏、获取 ticket 等方法。
 */
export function handleTCaptcha(captchaAppId, callback, loadErrorCallback, options = {}) {
    try {
        let captcha = null;

        const { type = 'popup', getContainer = 'body', ...restOptions } = options;
        if (type === 'embed') {
            // 场景一：嵌入指定容器展示
            captcha = new window.TencentCaptcha(
                document.querySelector(getContainer),
                captchaAppId,
                callback,
                {
                    userLanguage: Cookies.get('language'),
                    type,
                    ...restOptions,
                }
            );
        } else {
            // 场景二：以浮层形式居中弹出
            captcha = new window.TencentCaptcha(captchaAppId, callback, {
                userLanguage: Cookies.get('language'),
                ...restOptions,
            });
        }

        captcha.show();
        return captcha;
    } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        if (loadErrorCallback) {
            loadErrorCallback(error);
        }
    }
}

export function setLinkFavicon(href) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = href;
    document.getElementsByTagName('head')[0].appendChild(link);
}
